import React from 'react';
import PolicyPageLayout from '../components/PolicyPageLayout';

const ReturnExchangePolicyPage = () => {
  return (
    <PolicyPageLayout title="Returns & Exchanges Policy">
      <h2>Return Window</h2>
      <p>
        You have <strong>2 days</strong> from the date of delivery to initiate a return for your item.
      </p>

      <h2>Conditions for Return</h2>
      <ul>
        <li>The item must be unused, unworn, and in its original condition.</li>
        <li>It must be returned in its original packaging with all tags attached.</li>
        <li>Proof of purchase (order confirmation or invoice) is required.</li>
      </ul>

      <h2>How to Initiate a Return</h2>
      <p>
        To start a return, please contact our customer support team at <strong>monvistyles@gmail.com</strong> or WhatsApp us at <strong>+91 9676111210</strong>. Our team will provide you with detailed instructions. Securely pack the item and ship it to the address provided by our team.
      </p>
      
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 my-6">
        <h4 className="font-bold text-yellow-800">Unboxing Video for Wrong/Damaged Items</h4>
        <p className="text-yellow-700">
          If you believe you have received the wrong or a damaged saree, a <strong>parcel opening video is mandatory</strong> for us to process your claim. The video must be continuous, without any cuts or edits.
        </p>
      </div>

      <h2>Refunds</h2>
      <p>
        Once we receive and inspect the returned item, we will process your refund within <strong>7-14 business days</strong>. The refund will be credited to your original payment method. Please note that any shipping charges are non-refundable.
      </p>

      <h2>Exchanges</h2>
      <p>
        For exchanges, please contact our customer support team. They will guide you through the process based on product availability.
      </p>
      
      <h2>Please Note</h2>
      <p>Returns will not be entertained for reasons of slight differences in color or material feel, as screen resolutions and fabric textures can vary.</p>
    </PolicyPageLayout>
  );
};

export default ReturnExchangePolicyPage;